// src/components/chat/ChatUnreadBadge.jsx
import React, { useMemo } from 'react';
import { useGetChatsQuery } from '../../store/api/chatApi';
import styles from './ChatUnreadBadge.module.css';

/**
 * Shows the total unread message count across all conversations.
 *
 * Reads from the RTK Query getChats cache — no extra network request.
 * Updates in real-time via the global SignalR handler in App.jsx.
 */
export default function ChatUnreadBadge({ onClick, className = '' }) {
  const { data, isLoading } = useGetChatsQuery(undefined, {
    // Don't trigger a new fetch just because this component mounted.
    // The global cache is already kept live by SignalR.
    refetchOnMountOrArgChange: false,
  });

  // FIX: `data` is the array itself — getChats transformResponse returns
  // the normalized array directly, not an object with a `chats` property.
  // `data?.chats` was always undefined → chats was always [] → badge never showed.
  const chats = data ?? [];

  const totalUnread = useMemo(
    () => chats.reduce((sum, chat) => sum + (chat.unreadCount ?? 0), 0),
    [chats]
  );

  if (isLoading || totalUnread === 0) return null;

  return (
    <div
      className={`${styles.badge} ${className}`}
      onClick={onClick}
      aria-label={`${totalUnread} unread message${totalUnread !== 1 ? 's' : ''}`}
      title={`${totalUnread} unread message${totalUnread !== 1 ? 's' : ''}`}
    >
      {totalUnread > 99 ? '99+' : totalUnread}
    </div>
  );
}